import { Chip } from '@mui/material';
import React from 'react';
import { AuditActionType } from 'types/audits';
import { ChipPropsColor } from 'types/common';

interface IAuditActionTypeChipProps {
	actionType?: AuditActionType;
}

const AuditActionTypeChip: React.FC<IAuditActionTypeChipProps> = ({
	actionType
}) => {
	let color: ChipPropsColor;

	switch (actionType) {
		case 'info':
			color = 'info';
			break;
		case 'warn':
			color = 'warning';
			break;
		case 'error':
			color = 'error';
			break;
		default:
			color = 'default';
	}

	return (
		<Chip
			label={intl.tr(`audit.action.type.${actionType}`)}
			title={intl.tr(`audit.action.type.${actionType}`)}
			variant="outlined"
			size="small"
			color={color}
		/>
	);
};

AuditActionTypeChip.defaultProps = {
	actionType: 'unknown'
};

export default AuditActionTypeChip;
